interface PageHeroProps {
  eyebrow: string;
  title: string;
  description: string;
}

/**
 * Dark hero at the top of the inner pages, built from the redesign mockup's
 * homepage hero: the same grid, light beams, status pill and type styles.
 */
export function PageHero({ eyebrow, title, description }: PageHeroProps) {
  return (
    <section className="dc" style={{ position: "relative", overflow: "hidden", background: "#070B16", color: "#E8ECF4", fontFamily: "'IBM Plex Sans', 'Helvetica Neue', sans-serif" }}>
      <div className="grid-bg" aria-hidden="true" style={{ position: "absolute", inset: "0" }}></div>
      <svg aria-hidden="true" viewBox="0 0 1440 820" preserveAspectRatio="none" style={{ position: "absolute", inset: "0", width: "100%", height: "100%", opacity: ".7" }}>
        <path className="beam" d="M0 192 H1440" stroke="#7C97FF" strokeWidth="1" fill="none"></path>
        <path className="beam2" d="M0 448 H1440" stroke="#F2B544" strokeWidth="1" fill="none"></path>
        <path className="beam" d="M896 0 V820" stroke="#7C97FF" strokeWidth="1" fill="none" style={{ animationDuration: "8s" }}></path>
        <path className="beam2" d="M1152 0 V820" stroke="#7C97FF" strokeWidth="1" fill="none"></path>
      </svg>

      <div style={{ position: "relative", maxWidth: "1280px", margin: "0 auto", padding: "96px 32px 72px" }}>
        <div style={{ maxWidth: "780px" }}>
          <div className="in d1" style={{ display: "inline-flex", alignItems: "center", gap: "10px", padding: "8px 16px 8px 12px", border: "1px solid rgba(255,255,255,.12)", borderRadius: "999px", background: "rgba(255,255,255,.03)", fontSize: "13px", letterSpacing: ".02em", color: "#C9D1E0" }}>
            <span className="dot" style={{ width: "8px", height: "8px", borderRadius: "50%", background: "#4ADE80" }}></span>
            {eyebrow}
          </div>
          <h1 className="in d2" style={{ fontFamily: "Sora, sans-serif", fontWeight: "600", fontSize: "clamp(2rem, 3.8vw, 3.2rem)", lineHeight: "1.1", letterSpacing: "-0.03em", margin: "28px 0 0", color: "#fff" }}>{title}</h1>
          <p className="in d3" style={{ margin: "24px 0 0", maxWidth: "640px", fontSize: "18px", lineHeight: "1.65", color: "#A9B2C5" }}>{description}</p>
        </div>
      </div>
    </section>
  );
}
